import {gql} from "@apollo/client";

export default gql`
  mutation ratingAllWorker($data: AllWorkerRatingInput!) {
    ratingAllWorker(data: $data) 
  }
`;
